import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { PLACEHOLDERS, SEARCH_BY, SearchBy } from '@common/interfaces';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-vendor-search',
  templateUrl: './vendor-search.component.html',
  styleUrls: ['./vendor-search.component.scss']
})
export class VendorSearchComponent implements OnInit, OnDestroy {
  @Output() searchData = new EventEmitter<any>();

  searchStr: string = '';
  activeCol: { title: string; value: string }[] = [];
  searchOptions = [
    { title: 'Vendor Name', value: 'VENDOR_NAME' },
    { title: 'Vendor Email', value: 'VENDOR_EMAIL' },
    { title: 'Vendor Phone No.', value: 'VENDOR_PHONE_NUMBER' }
  ];

  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;
  ngOnInit(): void {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.emitSearchData()
    })
  }
  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe()
  }
  changeIndex(event: any) {
    this.activeCol = this.searchOptions.filter(
      (option) => option.value === event
    );
  }
  removeClick() {
    this.searchStr = '';
    this.emitSearchData();
  }

  search() {
    this.emitSearchData();
  }

  onInputChange() {
    this.searchSubject.next(this.searchStr)
  }

  private emitSearchData() {
    this.searchData.emit({
      searchBy: this.activeCol[0]?.value || 'VENDOR_NAME',
      searchText: this.searchStr
    });
  }

  get searchPlaceholder(): string {
    const selectedValue = this.activeCol[0]?.value as SearchBy || SEARCH_BY.VENDOR_NAME;
    return PLACEHOLDERS[selectedValue] || PLACEHOLDERS[SEARCH_BY.VENDOR_NAME];
  }
}
